/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
$(function() {
    $('#marketing_live_chat').on('click', function() {
        if (typeof SnapEngage !== 'undefined') {
            return SnapEngage.startLink();
        }
    });

    //marketing contact form ajax script
    $('.marketing-contact-form').on('submit', function submitForm(e) {
        e.preventDefault();

        var form = this;
        var $submitButton = $('#marketing_submit');
        var $formInputs = $('#marketing-form-inputs');
        var $formExtras = $('#marketing-form-extras');
        var $progressSpinner = $('<i class="progress-spinner icon-spinner icon-spin icon-large">');

        $submitButton.append($progressSpinner);
        $submitButton.prop('disabled', true);

        $.ajax({
            dataType: 'json',
            type: $(form).attr('method'),
            url: $(form).attr('action'),
            data: $(form).serialize()
        })
            .done(function(data) {
                //hide form and show a message about successful submission
                $formInputs.fadeOut(400, function() {
                    if (data.message) {
                        $formInputs.html('<div class="successful-submit">' + data.message + '</div>');
                        $formInputs.fadeIn();
                    }
                    $formExtras.hide();
                });
            })
            .fail(function(jqXHR) {
                if (jqXHR.responseText) {
                    var data = JSON.parse(jqXHR.responseText);
                    if (data.form) {
                        //replace the entire form and recreate submit event
                        $(form).replaceWith(data.form);
                        $('.marketing-contact-form').on('submit', submitForm);
                    }
                }
            })
            .always(function() {
                $progressSpinner.remove();
                $submitButton.prop('disabled', false);
            });
    });
});
